/**
 * Browser auto-execution
 */
import './polyfill';
import {BrowserInitializer} from './browser-initializer';

BrowserInitializer('AGEGO', window, navigator);
